const textOrPlaceholder = (test, text, placeholder = '---') =>
  test !== null && test !== undefined ? (text ?? placeholder) : placeholder;

export default textOrPlaceholder;
